import { useContext } from 'react'
import { CareContext } from '../contexts/CareContext'

export const useCare = () => {
  const context = useContext(CareContext)
  if (context === undefined) {
    throw new Error('useCare must be used within a CareProvider')
  }
  return context
} 